import { Avatar, Space, Typography } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';

const { Text } = Typography;

const ExternalResourceAvatar = ({ title, url, disabled, icon }) => {
    const avatar = (
        <Space>
            <Avatar size={'small'} icon={icon ? icon : null} />
            <Text disabled={disabled}>{title}</Text>
        </Space>
    );

    if (disabled) {
        return avatar;
    }
    return (
        <Link target={'_blank'} to={url}>
            {avatar}
        </Link>
    );
};

export default ExternalResourceAvatar;
